module.exports = __webpack_public_path__ + "static/media/client-northwestern.3218308b.png";